import React from 'react'

interface CloudLargeProps {
  width?: number
  height?: number
  className?: string
}

const CloudLarge: React.FC<CloudLargeProps> = ({ width = 1023, height = 865, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1023 865"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1022.94 572.126V570.468C1024.39 495.797 996.755 423.574 946.246 368.821C895.737 314.069 825.784 280.77 751.198 276.239C736.053 199.576 695.175 130.439 635.157 80.233C620.893 68.2972 605.733 57.6234 589.889 48.242C540.535 18.1516 483.297 0.802837 422.246 0.46833C422.003 0.46833 421.775 0.453125 421.532 0.453125C421.349 0.453125 421.167 0.453125 421 0.453125C420.818 0.453125 420.635 0.453125 420.468 0.453125C420.225 0.453125 419.997 0.46833 419.754 0.46833C358.703 0.802837 301.465 18.1364 252.111 48.2116C236.267 57.593 221.107 68.2668 206.843 80.2026C146.84 130.424 105.947 199.561 90.8016 276.208C16.2005 280.74 -53.7523 314.038 -104.246 368.791C-154.755 423.559 -182.386 495.797 -180.943 570.453V572.11C-181.718 610.822 -174.533 649.321 -160.056 685.159C-145.58 720.996 -124.024 753.748 -96.6203 781.056C-69.2164 808.379 -36.6173 830.061 -0.797852 844.551C35.0064 859.148 73.5754 866.233 112.251 865.686C149.772 865.686 235.993 866.248 332.879 867.009L334.125 868.453C362.395 868.21 391.667 867.967 421 867.723C450.333 867.967 479.621 868.21 507.875 868.453L509.121 867.009C606.007 866.264 692.228 865.686 729.749 865.686C768.425 866.233 806.994 859.163 842.798 844.551C878.602 830.061 911.201 808.379 938.62 781.056C966.024 753.732 987.58 720.996 1002.06 685.159C1016.53 649.321 1023.72 610.822 1022.94 572.11V572.126Z"
        fill="#008DA4"
      />
    </svg>
  )
}

export default CloudLarge
